// extracted by mini-css-extract-plugin
export var container = "features-module--container--a7TSL";
export var img_container = "features-module--img_container--d7o8Z";
export var info = "features-module--info--wftGL";
export var item = "features-module--item--dfldp";